import { useContext } from 'react';

import { LEAD_ID_COOKIE_NAME } from 'pages/leads/constants';
import { node } from 'prop-types';
import { useCookies } from 'react-cookie';
import { Redirect, Route } from 'react-router-dom';

import { RootContext } from '../leads-provider';

const LeadsPrivateRoute = ({ children, ...rest }) => {
  const context = useContext(RootContext);

  const [cookies] = useCookies([LEAD_ID_COOKIE_NAME]);
  const leadIdCookie = cookies[LEAD_ID_COOKIE_NAME];

  return (
    <Route
      {...rest}
      render={({ location }) =>
        leadIdCookie ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: context?.appUrls.PRE_SIGNUP_URL,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

LeadsPrivateRoute.propTypes = {
  children: node.isRequired,
};

export default LeadsPrivateRoute;
